import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import {
    ProSidebar,
    Menu,
    MenuItem,
    SubMenu,
    SidebarHeader,
    SidebarFooter,
    SidebarContent,
} from "react-pro-sidebar";
import { makeStyles } from "@material-ui/core/styles";
import "./scss/styles.scss";
import { useTranslation } from "react-i18next";
import MenuTitle from "./components/MenuTitle";
import {
    FaKey,
    FaPen,
    FaBoxes,
    FaFileArchive,
    FaInfoCircle,
    FaPowerOff,
    FaAngleRight,
    FaPallet,
} from "react-icons/fa";
import { IoHomeSharp } from "react-icons/io5";
import menuService from "../service/menuService";
import * as React from "react";
/**
 * @author Lucas Coelho
 * 03/05/2021
 */
import { NewVersionDialog } from "./components/VersionDialog/NewVersionDialog";

const useStyles = makeStyles((theme) => ({
    icon: {
        height: 20,
        width: 20,
    },
    link: {
        borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
        paddingTop: 8,
    },
    title: {
        fontStyle: "bold",
        textAlign: "center",
    },
    flexTop: {
        alignItems: "flexTop",
    },
}));

const Sidebar = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [toggled, setToggled] = useState(false);
    const classes = useStyles();

    const [collapsed, setCollapsed] = useState(true);
    const [menus, setMenus] = useState([]);

    //To add a new menu, add a new line following the pattern below
    const [registration, setRegistration] = useState();
    const [materialPicking, setMaterialPicking] = useState();

    useEffect(() => {
        const userId = sessionStorage.getItem("userId");
        menuService
            .getMenu({ loggedUserId: userId })
            .then((response) => {
                if (response.status === 200) {
                    setMenus(response.data);
                }
            })
            .catch((response) => { });
    }, []);

    useEffect(() => {
        menus.forEach(createMenuItem);
    }, [menus]);

    const createMenuItem = (menu) => {
        //To add a new menu, add a new case statement following the pattern below
        switch (menu.translationString) {
            case "registration":
                setRegistration(menu);
                break;
            case "materialPicking":
                setMaterialPicking(menu);
                break;
            default:
                break;
        }
    };

    const createLink = (item, isLast) => {
        debugger;
        return (
            <MenuItem key={item.subMenuId}>
                <Link to={item.link}>{t(item.translationString)}</Link>
                {!isLast ? <div className={classes.link} /> : null}
            </MenuItem>
        );
    };

    const handleCollapse = () => {
        setCollapsed(!collapsed);
    };

    const handleToggleSidebar = (value) => {
        setToggled(value);
    };

    const handleLogout = () => {
        sessionStorage.clear();
        history.replace("/");
    };

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div
            id="sidebar"
            style={{
                zIndex: 9999,
                position: "fixed",
            }}
        >
            <ProSidebar
                image={false}
                rtl={false}
                collapsed={collapsed}
                toggled={toggled}
                onToggle={handleToggleSidebar}
            >
                <SidebarHeader>
                    <div
                        style={{
                            marginTop: "10px",
                        }}
                    >
                        <Menu>
                            <MenuItem
                                icon={<FaAngleRight className="arrow-toggle-collapse" />}
                                onClick={handleCollapse}
                            >
                                {t("collapse")}
                            </MenuItem>
                        </Menu>
                        <Menu>
                            <MenuItem
                                icon={<IoHomeSharp className={classes.icon} />}
                                onClick={() => history.push("/home")}
                            >
                                {t("home")}
                            </MenuItem>
                        </Menu>
                    </div>
                </SidebarHeader>

                <SidebarContent>
                    {/* To add a new menu, add a new menu item following the pattern below  */}
                    {registration?.subMenus && (
                        <Menu>
                            <SubMenu
                                title={t("registration")}
                                icon={<FaPen className={classes.icon} />}
                            >
                                {collapsed ? (
                                    <MenuTitle title={registration.translationString} />
                                ) : null}
                                {registration.subMenus.map((item, i, arr) =>
                                    createLink(item, arr.length - 1 === i)
                                )}
                            </SubMenu>
                        </Menu>
                    )}
                    {materialPicking?.subMenus && (
                        <Menu>
                            <SubMenu
                                title={t("materialPicking")}
                                icon={<FaPallet className={classes.icon} />}
                            >
                                {collapsed ? (
                                    <MenuTitle title={materialPicking.translationString} />
                                ) : null}
                                {materialPicking.subMenus.map((item, i, arr) =>
                                    createLink(item, arr.length - 1 === i)
                                )}
                            </SubMenu>
                        </Menu>
                    )}
                </SidebarContent>
                <SidebarFooter>
                    <Menu>
                        <MenuItem
                            icon={<FaInfoCircle className={classes.icon} />}
                            onClick={handleOpen}
                        >
                            {t("info")}
                        </MenuItem>
                    </Menu>
                    <Menu>
                        <MenuItem
                            icon={<FaPowerOff className={classes.icon} />}
                            onClick={handleLogout}
                        >
                            {t("logout")}
                        </MenuItem>
                    </Menu>
                </SidebarFooter>
            </ProSidebar>

            {open ?
                (<NewVersionDialog dialog={handleClose} dialogOpen={open} />)
                : null}

        </div>
    );
});

export default Sidebar;
//FIM - LCoelho - OS: 17894 - ET: 03 - 29/04/2021 - Initial development
